import React from 'react';
import styled from 'styled-components';

const STRATEGY_URL = 'https://isf.trueimpact.com';

export default function Strategy() {
  return (
    <StrategyFrame
      src={STRATEGY_URL}
      title="Strategy"
      allow="fullscreen"
    />
  );
}

const StrategyFrame = styled.iframe`
  display: block;
  width: 100%;
  /* subtract the header height plus its 1px bottom border */
  height: calc(100vh - var(--app-header-height) - 1px);
  border: 0;
`;
